import {getBookingList} from '../../api/station'

const state = {
  totalCount: 0,
  current: 1,
  size: 10,
  bookingList: []
}
const mutations = {
  SET_BOOKING_LIST: (state, bookingList) => {
    console.log('bookingList = ', bookingList)
    state.bookingList = bookingList
  },
  SET_TOTAL_COUNT: (state, totalCount) => {
    console.log('totalCount = ', totalCount)
    state.totalCount = totalCount
  },
  SET_CURRENT: (state, current) => {
    console.log('current = ', current)
    state.current = current
  },
  SET_SIZE: (state, size) => {
    console.log('size = ', size)
    state.size = size
  }
}

const actions = {
  requestBookingList({ commit }, data) {
    console.log('data = ', data)
    return new Promise((resolve, reject) => {
      getBookingList(data).then(response => {
        console.log('SET_BOOKING_LIST = ', response)
        commit('SET_BOOKING_LIST', response.data.list)
        commit('SET_TOTAL_COUNT', response.data.totalCount)
        resolve()
      }).catch(error => {
        commit('SET_BOOKING_LIST', [])
        console.log('error = ', error)
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js